<template>
  <v-dialog v-model="showDialogImportAgentQuickResponse" width="420" persistent>
    <v-card>
      <div class="quick-response-dialog-header">
        <div class="quick-response-dialog-title">
          {{ $t('importAgentQuickResponse') | capitalize }}
        </div>
        <v-spacer></v-spacer>
        <v-btn flat icon @click="cancel">
          <v-icon color="#8B8FA3">mdi-close</v-icon>
        </v-btn>
      </div>
      <v-form ref="importAgentQuickResponseForm" class="quick-response-form">
        <span>
          {{ $t('prepareDataByTemplate') }}
              <a class="action-link" @click="download_data_template">{{ $t('downloadDataTemplate') }}</a>
        </span>
          
        <br>
        <br>
        <input type="file" ref="fileInput"  class="custom-file-input">
        <br>
        <br>
        <div class="dialog-action">
          <v-btn small outline color="#0052CC" style="margin-left: auto" @click="cancel">{{$t('cancel') | capitalize}}</v-btn>
          <v-btn small color="#0052CC" class="white--text" @click="submit">{{$t('save') | capitalize}}</v-btn>
        </div>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions, mapState} from "vuex";
import FormMixin from "@/mixins/FormMixin";
import {mapFields} from "vuex-map-fields";

export default {
  name: "DialogImportAgentQuickResponse",
  mixins: [FormMixin],
  data() {
    return {
      hideDetails: true
    }
  },
  computed: {
    ...mapState('dialog', ['showDialogImportAgentQuickResponse']),
    ...mapState('agentQuickResponse', ['type']),
    ...mapFields('agentQuickResponse', ["file"]),
  
  },
  methods: {
    ...mapActions('dialog', ['closeDialogImportAgentQuickResponse']),
    ...mapActions('agentQuickResponse', ['handleFileUpload']),
    submit() {
      if (this.$refs.importAgentQuickResponseForm.validate()) {
        this.file = this.$refs.fileInput.files[0];
      
        this.handleFileUpload()
        this.$refs.fileInput.value = null;
        this.$refs.importAgentQuickResponseForm.reset()
      }
      else {
        this.hideDetails = false
        this.$refs.fileInput.value = null;
      }
    },
    download_data_template(){
      if(this.type == 0) {
        window.location = "/data_template/Agent_quick_response_template.xlsx"
      }
      else{
        window.location = "/data_template/Agent_quick_response_leader_template.xlsx"
      }
    },
    cancel() {
      this.$refs.importAgentQuickResponseForm.reset()
      this.hideDetails = true;
      this.closeDialogImportAgentQuickResponse()
    },
    onAddVariable(item) {
      if(this.content  !== undefined) {
        this.content = this.content + `{${item}}`
      }
      else {
        this.content = `{${item}}`
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "components/style/dialog-create-quick-response";
</style>
